import MapperConfigEditor from './MapperConfigEditor.vue';
function defaultMapperConfig() {
  return {
    version: 1,
    output: 'direct',
    emit: []
  };
}
function copyEntry(entry) {
  const mapperEntry = {
    ...(entry || {})
  };
  delete mapperEntry.uiKey;
  delete mapperEntry._uiKey;
  delete mapperEntry.__uiKey;
  return {
    ...mapperEntry,
    mapperConfig: mapperEntry.mapperConfig ? {
      ...mapperEntry.mapperConfig
    } : defaultMapperConfig(),
    topic: mapperEntry.topic || ''
  };
}
function entrySignature(entry) {
  return JSON.stringify(copyEntry(entry));
}
export default {
  name: 'TopicMapperListEditor',
  components: {
    MapperConfigEditor
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      nextUiKey: 0,
      uiKeys: [],
      entrySignatures: []
    };
  },
  computed: {
    entries() {
      return Array.isArray(this.value) ? this.value : [];
    },
    keyedEntries() {
      return this.entries.map((entry, index) => ({
        entry,
        uiKey: this.uiKeys[index]
      }));
    },
    mapperErrorPolicyItems() {
      return [{
        text: 'Partial',
        value: 'partial'
      }, {
        text: 'Reject message',
        value: 'rejectMessage'
      }];
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.syncUiKeys();
      }
    }
  },
  methods: {
    createUiKey() {
      const uiKey = `topic-mapper-${this.nextUiKey}`;
      this.nextUiKey += 1;
      return uiKey;
    },
    syncUiKeys() {
      const nextSignatures = this.entries.map(entrySignature);
      if (this.uiKeys.length === this.entries.length && this.entrySignatures.length === this.entries.length) {
        const sameEntries = nextSignatures.every((signature, index) => signature === this.entrySignatures[index]);
        if (!sameEntries) {
          this.uiKeys = this.entries.map(() => this.createUiKey());
        }
      }
      while (this.uiKeys.length < this.entries.length) {
        this.uiKeys.push(this.createUiKey());
      }
      if (this.uiKeys.length > this.entries.length) {
        this.uiKeys.splice(this.entries.length);
      }
      this.entrySignatures = nextSignatures;
    },
    nextEntries() {
      return this.entries.map(copyEntry);
    },
    emitEntries(entries) {
      this.$emit('input', entries);
    },
    addEntry() {
      this.emitEntries([...this.nextEntries(), {
        topic: '',
        mapperConfig: defaultMapperConfig()
      }]);
    },
    updateEntry(index, patch) {
      const entries = this.nextEntries();
      entries.splice(index, 1, {
        ...entries[index],
        ...patch
      });
      this.emitEntries(entries);
    },
    updateMapperErrorPolicy(index, mapperErrorPolicy) {
      const entries = this.nextEntries();
      if (mapperErrorPolicy) {
        entries[index].mapperErrorPolicy = mapperErrorPolicy;
      } else {
        delete entries[index].mapperErrorPolicy;
      }
      this.emitEntries(entries);
    },
    removeEntry(index) {
      const entries = this.nextEntries();
      entries.splice(index, 1);
      this.uiKeys.splice(index, 1);
      this.emitEntries(entries);
    },
    moveEntry(index, direction) {
      const targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= this.entries.length) {
        return;
      }
      const entries = this.nextEntries();
      const [uiKey] = this.uiKeys.splice(index, 1);
      this.uiKeys.splice(targetIndex, 0, uiKey);
      const [entry] = entries.splice(index, 1);
      entries.splice(targetIndex, 0, entry);
      this.entrySignatures = entries.map(entrySignature);
      this.emitEntries(entries);
    }
  }
};